import toast from 'react-hot-toast'
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred'
import { Box, Link, SxProps, Typography } from '@mui/material'

import { FlowSessionState, ModalWrapProps } from 'common/interfaces'
import ModalActionCancelButtons from 'components/Modals/components/ModalActionCancelButtons'
import ModalWrap from 'components/ModalWrap'
import { SaveFlowButton as SaveFlowButtonProps } from 'elements/SaveFlowButton/interface'
import { useFlow, useFlowSlug } from 'utils/flow'
import { useLocalStorage } from 'utils/hook'

type SaveFlowSessionLinkModalProps = Pick<ModalWrapProps, 'open' | 'onClose' | 'title'> &
  Pick<SaveFlowButtonProps, 'textModal' | 'textCopyButtonModal' | 'textCancelButtonModal'>

const style: Record<string, SxProps> = {
  wrap: {
    marginBottom: {
      xs: '24px',
      md: '16px',
    },
  },
  icon: {
    marginRight: '12px',
    color: 'red',
  },
}

export default function SaveFlowSessionLinkModal({
  open,
  onClose,
  title,
  textModal,
  textCopyButtonModal,
  textCancelButtonModal,
}: SaveFlowSessionLinkModalProps): JSX.Element {
  const { wrap, icon } = style

  const { data: flowData } = useFlow()
  const flowSlug = useFlowSlug()
  const [sessionFlowIdLS] = useLocalStorage<FlowSessionState['id'] | null>(
    `${flowSlug}/sessionFlowId`,
    null
  )
  const sessionFlowLink = `${location.origin}${location.pathname}?s_id=${
    flowData!.flow_session.id ?? sessionFlowIdLS
  }`

  const copyLinkHandler = async (): Promise<void> => {
    try {
      await navigator.clipboard.writeText(sessionFlowLink)
      toast.success('Your link was copied successfully')
    } catch {
      toast.error("Sorry, your link didn't copied")
    }
  }

  return (
    <ModalWrap
      title={title}
      onClose={onClose}
      open={open}
      actions={
        <ModalActionCancelButtons
          actionHandler={() => {
            void copyLinkHandler()
          }}
          onClose={onClose}
          textAction={textCopyButtonModal!}
          textCancel={textCancelButtonModal!}
        />
      }
    >
      <Box display="flex" sx={wrap}>
        <ReportGmailerrorredIcon sx={icon} />
        <Typography>{textModal}</Typography>
      </Box>
      <Link href={sessionFlowLink} color="primary.main">
        {sessionFlowLink}
      </Link>
    </ModalWrap>
  )
}
